import { axiosAuth, axiosPlatform } from "../../../_services/axios-helper";

export const organizationService = {
    getOrganization,
    updateOrganization,
    registerUserToOrganization,
    removeUserFromOrganization,
    updateAllowedApps,
    getHubspotProperties,
    sendHubspotAnalytics,
    getDashboardData,
    getTaxAgencyDashboardData,
    getTaxAgencyOrgDetails,
    createScheduledTask,
    updateScheduledTask,
    restartScheduledTask,
    updateLastImportDate,
    removeDeletionDateFromOrganization,
    migrateToStripe,
    getTaxAgencyEmployees,
    getTaxAgencyMandanten,
    createTaxAgencyEmployee,
};

function getOrganization() {
    return axiosAuth().get("/platform/organization");
}

function updateOrganization(organization) {
    return axiosAuth().post("/platform/organization/update", organization);
}

function registerUserToOrganization(registrationRequest) {
    return axiosAuth().post("/platform/organization/registeruser", registrationRequest);
}

function removeUserFromOrganization(user, organizationUUID) {
    return axiosAuth().post("/platform/organization/removeuser/" + organizationUUID, user);
}

function updateAllowedApps(organizationUUID, allowedApps) {
    return axiosAuth().post("/platform/organization/updateallowedapps/" + organizationUUID, allowedApps);
}

function getHubspotProperties(requestDto) {
    return axiosAuth().post("/platform/organization/get-hubspot-organization-properties", requestDto);
}

function getDashboardData() {
    return axiosPlatform().get("/dashboard");
}

function getTaxAgencyDashboardData() {
    return axiosPlatform().get("/dashboard/tax-agency");
}

function getTaxAgencyOrgDetails(organizationUUID) {
    return axiosPlatform().get(`/dashboard/tax-agency/${organizationUUID}/details`);
}

function sendHubspotAnalytics(organizationUUID, requestBody) {
    return axiosAuth().post("/platform/organization/send-hubspot-analytics/" + organizationUUID, requestBody);
}

function createScheduledTask(requestDto) {
    return axiosPlatform().post("/task-management/scheduler/schedule-task", requestDto);
}

function updateScheduledTask(taskUUID, requestDto) {
    return axiosPlatform().put(`/task-management/scheduler/${taskUUID}`, requestDto);
}

function restartScheduledTask(taskUUID) {
    return axiosPlatform().post(`/task-management/scheduler/${taskUUID}/restart`);
}

function updateLastImportDate(taskUUID, date) {
    return axiosPlatform().put(`/task-management/scheduler/${taskUUID}/last-successful-import`, { date });
}

function removeDeletionDateFromOrganization(organizationUUID) {
    return axiosAuth().post(`/platform/organization/${organizationUUID}/remove-deletion-date`);
}

function migrateToStripe(organizationUUID, businessAddress) {
    return axiosAuth().post("/platform/organizations/" + organizationUUID + "/migrate-to-stripe", {
        organizationUUID: organizationUUID,
        businessAddress: businessAddress,
    });
}

function getTaxAgencyEmployees() {
    return axiosAuth().get("/platform/organization/tax-agency/employees");
}

function getTaxAgencyMandanten() {
    return axiosAuth().get("/platform/organization/tax-agency/mandanten");
}

function createTaxAgencyEmployee(request) {
    return axiosAuth().post("/platform/organization/tax-agency/employees", request);
}
